import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { DeleteIcon } from '@treams/treams-icons';
import { Button, ContextMenu, Paragraph, Subheading } from '@treams/treams-ui';

import { PopoverArrow, PopoverContainer, PopoverContents } from './Popover';

export default function PopoverConfirm({
	onConfirm,
	title,
	description,
	confirmButtonTitle,
	cancelButtonTitle,
	actionType,
	onMouseLeave,
}: {
	onConfirm: (confirmed: boolean) => void;
	title: string;
	description: string;
	confirmButtonTitle?: string;
	cancelButtonTitle?: string;
	actionType?: 'menu' | 'delete';
	onMouseLeave?: () => void;
}) {
	const { t } = useTranslation();

	const [action, setAction] = useState<'menu' | 'delete'>(actionType || 'menu');

	return (
		<PopoverContainer>
			<PopoverArrow />
			<PopoverContents p={3} onMouseLeave={onMouseLeave}>
				{action === 'menu' && (
					<ContextMenu.Item
						icon={<DeleteIcon />}
						onClick={() => setAction('delete')}
						title={t('common.delete')}
						type="destructive"
					/>
				)}

				{action === 'delete' && (
					<>
						<Box mb={3}>
							<Subheading>{title}</Subheading>
							<Paragraph>{description}</Paragraph>
						</Box>

						<Flex justifyContent="flex-end">
							<Button
								onClick={(event) => {
									event.stopPropagation();
									onConfirm(false);
								}}
								title={cancelButtonTitle ?? t('common.cancel')}
								type="secondary"
							/>
							<Button
								onClick={(event) => {
									event.stopPropagation();
									onConfirm(true);
								}}
								title={confirmButtonTitle ?? t('common.confirm')}
								ml={2}
							/>
						</Flex>
					</>
				)}
			</PopoverContents>
		</PopoverContainer>
	);
}
